<div class="container-fluid p-0">
  <div class="row">
    <div class="text-center mb-3">
    </div>
  </div>
  @if (alertInfo.show) {
    <div class="row mb-3">
      <div class="col-12">
        <ngb-alert [type]="alertInfo.type" (closed)="closeAlert()">
          {{ alertInfo.message }}
        </ngb-alert>
      </div>
    </div>
  }

  <div class="row">
    <div class="col-md-6 px-0 pe-3">
      <div class="card h-100">
        <div class="card-header justify-content-between  bg-light">
          <div class="d-flex justify-content-between align-items-center">
            <h5 class="mb-0">From Regulation</h5>
            <span class="badge bg-primary ms-2">{{ fromRegulation.length }}</span>
          </div>
          <div class="mt-2">
            <div class="input-group">
              <select class="form-select form-select-sm" [disabled]="!formFieldsComplete"
                (change)="filterByCategory($any($event.target).value ? +$any($event.target).value : null)">
                <option value="">All Categories</option>
                @for (category of categoryOptions; track category) {
                  <option [value]="category.key">{{
                  category.value }}</option>
                }
              </select>
            </div>
          </div>
        </div>
        <div class="card-body" style="max-height: 600px; overflow-y: auto;">
          @if (!formFieldsComplete) {
            <div class="alert alert-warning">
              <i class="fa fa-info-circle fa-lg me-2"></i>
              Please complete all required fields in the form above (Jurisdiction, Law, and Checklist) to view available regulations
            </div>
          }
          @if (formFieldsComplete) {
            <div class="list-group">
              @for (regulation of fromRegulation; track regulation) {
                <div
                  class="list-group-item list-group-item-action mb-2"
                  [ngClass]="{'opacity-50': isTemporarilySelected(regulation)}">
                  <div class="d-flex justify-content-between align-items-start">
                    <div>
                      <h6 class="mb-1">{{ regulation.title }}</h6>
                      <p class="mb-1 text-muted small">{{ regulation.details?.substring(0, 100)
                      }}{{ regulation.details?.length > 100 ? '...' : '' }}</p>
                      <div class="mt-2">
                        @for (category of regulation.categories; track category) {
                          <span
                            class="badge bg-primary me-1 mb-1">
                            {{ category.name }}
                          </span>
                        }
                      </div>
                      @if (isTemporarilySelected(regulation)) {
                        <div class="mt-2">
                          <span class="badge bg-secondary">Added to testlist</span>
                        </div>
                      }
                    </div>
                    <div class="ms-2 d-flex flex-column" style="gap: 8px;">
                      <button class="btn btn-light btn-sm" style="min-width: 36px;"
                        (click)="openDetails(regulation, detailModal)">
                        <i class="fa fa-eye"></i>
                      </button>
                      <button class="btn btn-sm" style="min-width: 36px;" [disabled]="isTemporarilySelected(regulation)"
                        [ngClass]="isTemporarilySelected(regulation) ? 'btn-secondary' : 'btn-success'"
                        (click)="toggleSelection(regulation)">
                        {{ isTemporarilySelected(regulation) ? '-' : '+' }}
                      </button>
                    </div>
                  </div>
                </div>
              }
              @if (fromRegulation.length === 0 && (jurisdictionId && lawId && checklistId)) {
                <div
                  class="text-center p-3">
                  <p class="text-muted">No regulations available</p>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>

    <div class="col-md-6 px-0">
      <div class="card h-100">
        <div class="card-header bg-light">
          <div class="d-flex justify-content-between align-items-center">
            <h5 class="mb-0">To New Testlist</h5>
            <span class="badge bg-success ms-2">{{ toNewTestlistTemp.length }}</span>
          </div>
        </div>
        <div class="card-body" style="max-height: 600px; overflow-y: auto;">
          <div class="rules-container">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h6 class="mb-0">Rules Selected From The Left</h6>
              <div class="btn-group btn-group-sm">
                <button class="btn btn-outline-secondary btn-sm" title="List View">
                  <img src="assets/flags/en.svg" alt="English" width="20" height="20">
                </button>
                <button class="btn btn-outline-secondary btn-sm" title="Card View">
                  <img src="assets/flags/es.svg" alt="Spain" width="20" height="20">
                </button>
                <button class="btn btn-outline-secondary btn-sm" title="Other View">
                  <img src="assets/flags/it.svg" alt="Italy" width="20" height="20">
                </button>
              </div>
            </div>

            @if (toNewTestlistTemp.length === 0) {
              <div class="alert alert-warning text-center">
                No regulation selected
              </div>
            }

            @for (regulationTest of toNewTestlistTemp; track regulationTest) {
              <div
                class="list-group-item list-group-item-action separator p-2 mb-2">
                <div class="row justify-content-between align-items-start">
                  <div class="col-md-10">
                    <h6 class="mb-1">{{ regulationTest.title }}</h6>
                    <p class="mb-1 text-muted small">{{ regulationTest.details?.substring(0, 100)
                    }}{{ regulationTest.details?.length > 100 ? '...' : '' }}</p>
                    <div class="mt-2">
                      @for (category of regulationTest.categories; track category) {
                        <span
                          class="badge bg-primary me-1 mb-1">
                          {{ category.name }}
                        </span>
                      }
                    </div>
                  </div>
                  <div class="col-md-2 d-flex align-items-center my-3" style="gap: 8px; justify-content: flex-end;">
                    <button class="btn btn-light btn-sm" style="min-width: 36px;"
                      (click)="openDetails(regulationTest, detailModal)">
                      <i class="fa fa-eye"></i>
                    </button>
                    <button class="btn btn-danger btn-sm" style="min-width: 36px;" (click)="toggleSelection(regulationTest)">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>

          <div class="mt-4">
            <form [formGroup]="form">
              <div class="mb-3">
                <input-field type="text" [inputFormControl]="getTestNameInput()" label="Test Name"
                  placeholder="Screen Test">
              </input-field>
            </div>

            <h6 class="mt-4">Estimated Time</h6>
            <div class="row g-2">
              <div class="col">
                <input-field type="number" [inputFormControl]="getEstimatedTimeHoursInput()"
                  label="Hours" placeholder="Hours">
              </input-field>
            </div>
            <div class="col">
              <input-field type="number" [inputFormControl]="getEstimatedTimeMinutesInput()"
                label="Minutes" placeholder="Minutes">
            </input-field>
          </div>
        </div>
      </form>

      <div class="mt-4">
        <h6 class="mb-2">TEST PROCEDURE</h6>
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" data-bs-toggle="tab"
              data-bs-target="#without-evidence" type="button" role="tab">WITHOUT
            EVIDENCE</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" data-bs-toggle="tab" data-bs-target="#with-evidence"
            type="button" role="tab">WITH EVIDENCE</button>
          </li>
        </ul>

        <div class="tab-content mt-3">
          <div class="tab-pane fade show active" id="without-evidence" role="tabpanel">
            @for (step of withoutEvidenceSteps; track step; let i = $index) {
              <div class="my-1">
                <div class="d-flex align-items-center">
                  <span class="me-2">Step #{{step.id}}</span>
                </div>
                <div class="d-flex justify-content-center align-items-center">
                  @if (withoutEvidenceFormControls[i]) {
                    <textarea-field class="w-100" [height]="100"
                      [textareaFormControl]="withoutEvidenceFormControls[i]"
                      placeholder="Insert step details"
                      (change)="updateStepContent(i, false)">
                    </textarea-field>
                  }
                  <div class="ms-2">
                    <button class="btn btn-light btn-sm" (click)="removeStep(i, false)">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            }
            <button class="btn btn-primary btn-sm" (click)="addStep(false)">
              <i class="fa fa-plus me-1"></i> Add another step
            </button>
          </div>

          <div class="tab-pane fade" id="with-evidence" role="tabpanel">
            @for (step of withEvidenceSteps; track step; let i = $index) {
              <div class="my-1">
                <div class="d-flex align-items-center">
                  <span class="me-2">Step #{{step.id}}</span>
                </div>
                <div class="d-flex justify-content-center align-items-center">
                  @if (withEvidenceFormControls[i]) {
                    <textarea-field class="w-100"
                      [height]="100" [textareaFormControl]="withEvidenceFormControls[i]"
                      placeholder="Insert step details" (change)="updateStepContent(i, true)">
                    </textarea-field>
                  }
                  <div class="ms-2">
                    <button class="btn btn-light btn-sm" (click)="removeStep(i, true)">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            }
            <button class="btn btn-primary btn-sm" (click)="addStep(true)">
              <i class="fa fa-plus me-1"></i> Add another step
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
</div>

<div class="row">
  <div class="col-md-6 col-sm-12 mt-3 ps-0">
    <regulations-changes-logs [auditLogs]="auditLogs" />
  </div>
</div>

<div class="row mb-3">
  <div class="col-12 d-flex justify-content-center mt-3">
    <button class="btn btn-secondary px-4 py-2 me-2">Cancel</button>
    <button class="btn btn-success px-4 py-2"
      [disabled]="toNewTestlistTemp.length === 0 || form.invalid || isSaving" (click)="saveTestlist()">
      {{ isSaving ? 'Saving...' : 'Save' }}
    </button>
  </div>
</div>
</div>

<!-- Detail Modal -->
<ng-template #detailModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Regulation Details</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    @if (detailRegulation) {
      <div>
        <h5>{{ detailRegulation.title }}</h5>
        <div class="mb-3">
          @for (category of detailRegulation.categories; track category) {
            <span class="badge bg-primary me-1">
              {{ category.name }}
            </span>
          }
        </div>
        <hr>
          <p class="mb-4" style="white-space: pre-line;">{{ detailRegulation.details }}</p>
        </div>
      }
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.close()">Close</button>
    </div>
  </ng-template>